import * as Sentry from "@sentry/vue";
import { BrowserTracing, type EventHint, type Event } from "@sentry/vue";
import "virtual:vite-plugin-sentry/sentry-config";
import type { App } from "vue";
import type { Router } from "vue-router";

// now you can use this variable like so
const dist = import.meta.env.VITE_PLUGIN_SENTRY_CONFIG.dist;
const release = import.meta.env.VITE_PLUGIN_SENTRY_CONFIG.release;
const environment = process.env.NODE_ENV;

// Sentry.init({
//   app,
//   dsn: "https://a196814f20f947a0899bc0e786ac0ceb@sentry.ist.com/9",
//   integrations: [
//     new Integrations.BrowserTracing({
//       routingInstrumentation: Sentry.vueRouterInstrumentation(router)
//     })
//   ],
//   environment: mainstore.state.mainConfig.ENVIRONMENTNAME,
//   debug: false,
//   logErrors: true,
//   trackComponents: true,
//   // We recommend adjusting this value in production, or using tracesSampler
//   // for finer control
//   tracesSampleRate: 1.0
// });

export default {
  install(app: App<Element>, router: Router) {
      Sentry.init({
      dist,
      app,
      dsn: "https://a196814f20f947a0899bc0e786ac0ceb@sentry.ist.com/9",
      release: release,
      environment: environment,
      integrations: [
        new BrowserTracing({
          routingInstrumentation: Sentry.vueRouterInstrumentation(router),  
          tracingOrigins: ["localhost", "ist.com", "ist.dk", /^\//]     
        })          
      ],       
      tracePropagationTargets: ["localhost", /^https:\/\/ist\.dk\//, /^https:\/\/ist\.com\//, /^\/ /],
      beforeSend(event: Event, _hint?: EventHint): any {
        if (event.extra && event.extra.propsData) {
          const s: string = JSON.stringify(event.extra.propsData);
          if (s.length > 10000) {
            event.extra.propsData = { jsonstring: s.substring(0, 10000) };
          }
        }

        return event;
      },
      // Set tracesSampleRate to 1.0 to capture 100%
      // of transactions for performance monitoring.
      // We recommend adjusting this value in production
      tracesSampleRate: 1.0
    });
    Sentry.configureScope((scope) => {
      scope.setTag("JENKINSID", import.meta.env.VITE_VUE_APP_VERSION || "");
    }); 

    app.config.errorHandler = (msg, vm, info) => {
      // eslint-disable-next-line
      console.error("errorHandler", msg, vm, info);
    };
  }
};
